import type React from 'react';
import { Stack, Typography } from '@mui/material';

function LabelValue({ label, value }: Props): React.ReactElement {
  return (
    <Stack direction="row" spacing={1} alignItems="baseline" flexWrap="wrap">
      <Typography variant="body2" color="text.secondary">
        {label}:
      </Typography>
      <Typography variant="body2" component="span">
        {value}
      </Typography>
    </Stack>
  );
}

interface Props {
  label: string;
  value: React.ReactNode;
}

export { LabelValue };
